<template>
  <div class="row justify-content-center">
    <!-- TODO: remove row/col classes before placing in mst.dk context -->
    <div class="product-info col-md-6 inherit-link-styling" role="main">
      <FetchError
        v-if="errorSingleProduct"
        errorMsg="Der er desværre sket en teknisk fejl, eller også eksisterer produktet med det givne ID ikke i vores database. Du kan prøve at genindlæse siden eller gå tilbage til listevisningen her:"
      >
        <button
          type="button"
          class="btn btn-primary mx-3"
          aria-label="Genindlæs siden"
          @click="$router.go()"
          @keyup.enter="$router.go()"
        >
          Genindlæs siden
        </button>
        <button
          type="button"
          class="btn btn-primary mx-3"
          aria-label="Gå til listevisning"
          @click="$router.push({ name: 'ListProducts' })"
          @keyup.enter="$router.push({ name: 'ListProducts' })"
        >
          Gå til listevisning
        </button>
      </FetchError>
      <div v-else>
        <div v-if="Object.keys(productCard).length > 0">
          <h1 class="page-title">{{ productCard.name }}</h1>

          <p style="color: var(--darkgrey); margin-top: 30px">
            {{
              getProductCategories().length > 1 ? "Kategorier: " : "Kategori: "
            }}
            <span
              v-for="(category, index) in getProductCategories()"
              :key="category.id"
              class="inherit-link-styling"
            >
              <span v-if="index > 0">; </span>
              <a v-if="category.id" @click="pushListProducts(category.id)">
                {{ category.name }}
              </a>
            </span>
          </p>

          <MultiImageDisplay :productCard="productCard" />

          <!-- <p style="color: var(--darkgrey); margin-top: 30px">
            Dato for {{ productCard.reaction.name_d ? productCard.reaction.name_d.toLowerCase() : "<data missing>" }}:
            {{ date(productCard.publicDate) }}
          </p> -->

          <h2 class="mt-5" style="color: var(--deepgreen)">{{ $store.state.products.content.ProductInfo.caseDevelopment }}</h2>
          <p>
            Kemikalieinspektionen har
            {{ getReactionLong(productCard.reaction.name_d) }}
            til
            {{ getResponsibleParty("mainResponsible") ? getResponsibleParty("mainResponsible") : "<data missing>"  }}
            vedrørende
            {{ productCard.name ? '"' + productCard.name + '"' : "nyheden" }}
            på baggrund af en overtrædelse af
            {{ productCard.fileClassGroup.name_d ? productCard.fileClassGroup.name_d + "." : "<data missing>" + "." }}
          </p>
          <p>
            {{ getReactionShort(productCard.reaction.name_d) }}
            er meddelt
            {{ getResponsibleParty("mainResponsible") ? getResponsibleParty("mainResponsible") + "," : "<data missing>" + "," }}
            og
            {{ getResponsibleParty("mainResponsible") ? getResponsibleParty("mainResponsible") : "<data missing>" }}
            bør have efterkommet
            {{ getReactionShort(productCard.reaction.name_d).toLowerCase() }}
            eller efterkomme snarest.
          </p>
          <p>
            Sagen er offentliggjort d.
            {{ date(productCard.publicDate) }}
            og slettes automatisk d.
            {{ getEndDate(productCard.publicDate) }}.
          </p>
          <p>{{ $store.state.products.content.ProductInfo.guideline }}</p>

          <div class="fact-box" style="margin-top: 30px">
            <p
              style="
                font-family: oxygen-bold;
                color: var(--deepgreen);
              "
              class="mb-2"
            >
              {{ $store.state.products.content.ProductInfo.reasonsTitle }}
            </p>
            <div
              v-html="
                productCard.reason
                  ? removeBreaksStyles(productCard.reason)
                  : '<p>Ikke angivet</p>'
              "
            ></div>
          </div>
          <p style="color: var(--darkgrey); margin-top: 30px">
            Myndighed:
            {{
              productCard.sourceType
                ? productCard.sourceType.name == "MST"
                  ? "Miljøstyrelsen"
                  : productCard.sourceType.name
                : "Ikke angivet"
            }}
          </p>
          <h2 style="margin: 40px 0 30px 0; color: var(--deepgreen)">
            {{ $store.state.products.content.ProductInfo.detailsTitle }}
          </h2>
          <div class="row">
            <div
              v-for="element in listInfo(productCard)"
              :key="element.id"
              class="col-lg-4 col-sm-4 col-md-6 col-6 product-numbers-list"
            >
              <p style="color: var(--deepgreen); margin-bottom: 0">
                {{ element.displayName }}
              </p>
              <p>
                {{ element.value ? element.value : "-" }}
              </p>
            </div>
          </div>

          <div v-if="productCard.links.length > 0">
            <p
              style="
                font-family: oxygen-bold;
                color: var(--deepgreen);
                margin: 20px 0 5px 0;
              "
            >
              {{ $store.state.products.content.ProductInfo.furtherInfoTitle }}
            </p>
            <ul>
              <div v-for="link in productCard.links" :key="link.url">
                <li>
                  <a
                    style="font-family: oxygen-regular"
                    :href="link.url.includes('//') ? link.url : '//' + link.url"
                    >{{ link.displayText }}</a
                  >
                </li>
              </div>
            </ul>
          </div>

          <div class="product-carousel" v-if="Object.keys($store.state.products.carouselCards).length > 0">
            <p
              style="
                font-family: oxygen-bold;
                color: var(--deepgreen);
                margin: 40px 0 5px 0;
              "
            >
              {{ $store.state.products.content.ProductInfo.viewMoreProducts }}
            </p>
            <Carousel
              style="width: 90%; margin: 0 auto"
              :loading="loadingCarouselProducts"
              :isWindowSmall="isWindowSmall"
              :maxProducts="12"
            />
          </div>

          <router-link
            :to="{ name: 'ListProducts' }"
            class="d-inline-flex mt-3"
          >
            <p style="font-family: oxygen-bold; color: var(--deepgreen)" class="mb-3">
              {{ $store.state.products.content.ProductInfo.goBackToListView }}
            </p>
          </router-link>
        </div>

        <div v-else class="justify-content-center">
          <div
            class="spinner-border m-5"
            role="status"
            style="color: var(--deepgreen); width: 10rem; height: 10rem"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getSingleProduct from "@/composables/getSingleProduct";
import MultiImageDisplay from "@/components/products/MultiImageDisplay.vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import FetchError from "@/components/FetchError.vue";
import Carousel from "@/components/products/Carousel.vue";
import axios from "axios";

export default {
  components: { MultiImageDisplay, FetchError, Carousel },
  data() {
    return {
      isWindowSmall: true,
      loadingCarouselProducts: true,
    };
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const {
      productCard,
      errorSingleProduct,
      loadSingleProduct,
    } = getSingleProduct(route.params.productId);

    loadSingleProduct().then(() => {
      console.log("productCard",productCard.value)
      store.state.products.productCard = productCard.value;
    });

    return {
      errorSingleProduct,
    };
  },
  watch: {
    productCard() {
      this.updateCarouselProducts();
    },
    $route() {
      if (this.$route.name == 'ProductInfo') {
      const {
        productCard,
        errorSingleProduct,
        loadSingleProduct,
      } = getSingleProduct(this.$route.params.productId);

      loadSingleProduct().then(() => {
        this.productCard = productCard.value;
        if (errorSingleProduct.value) {
          console.log(errorSingleProduct.value);
        }
      });
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.evaluateWindowSize);
    this.evaluateWindowSize();
  },
  unmounted() {
    window.removeEventListener("resize", this.evaluateWindowSize);
  },
  methods: {
    evaluateWindowSize() {
      this.isWindowSmall = window.innerWidth < 768;
    },
    updateCarouselProducts() {
      this.loadingCarouselProducts = true;

      //Get categories to show similar products
      let categories = this.productCard.productCategoryRelations
      let categoryIds = []
      if (categories.length > 0) {
        categories.forEach((category) => {
          categoryIds.push(Number(category.productCategoryTypeId))
        })
      }

      const callObject = JSON.stringify({
        page: this.$store.state.products.page,
        pageSize: this.$store.state.productsproductsPerPage,
        searchText: this.$store.state.products.searchTerm,
        productCategoryTypeIds: categoryIds,
        //Do not take reaction into account for similar products
        //reactionIds: [],
      });

      console.log(callObject);

      axios
        .post(
          process.env.VUE_APP_PRODUCTS_API + "product/search/mst",
          callObject,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          console.log(
            "Response from " + process.env.VUE_APP_PRODUCTS_API,
            response
          );
          this.$store.state.products.carouselCards = response.data.results.filter(
            (productCard) =>
              productCard.id !== Number(this.$route.params.productId)
          );
          this.loadingCarouselProducts = false;
        })
        .catch((error) => {
          console.log(
            "Response from " + process.env.VUE_APP_PRODUCTS_API,
            error
          );
          //TODO: show fetchError in Carousel
          this.fetchError = true;
        });
    },
    removeBreaksStyles(html) {
      return html
        .replace(/<br>/g, "")
        .replace(/style="[^"]*"/g, "")
        .replace(/style='[^']*'/g, "");
    },
    getProductCategories() {
      let categoryArray = [];
        if (this.productCard.productCategoryRelations.length > 0) {
          this.productCard.productCategoryRelations.forEach((element) => {
            if (element.productCategoryType.name_d) {
              categoryArray.push({
                name: element.productCategoryType.name_d.trim(),
                id: element.productCategoryType.id,
              });
            }
          });
        } else {
          categoryArray.push({ name: "Ikke angivet", id: null });
        }
      return categoryArray;
    },
    pushListProducts(id) {
      this.$store.commit("products/setCategoryFilters", {
        categoryFilters: [Number(id)],
      });
      this.$router.push({ name: "ListProducts" });
    },
    getResponsibleParty(type) {
      let output = "";
      if (this.productCard.responsibleParties.length > 0) {
        this.productCard.responsibleParties.forEach((party) => {
          if (party.responsibilityType.name) {
            if (
              party.responsibilityType.name.toLowerCase() == type.toLowerCase()
            ) {
              output = party.company.name;
            }
          }
        });
      }
      return output;
    },
    getReactionLong(input) {
      let reaction = "";
      if (input) {
        reaction = input.toLowerCase();
      }
      if (reaction == "indskærpelse") {
        return "meddelt en indskærpelse";
      } else if (reaction == "påbud") {
        return "givet et påbud";
      } else if (reaction == "forbud") {
        return "meddelt et forbud";
      } else {
        return "<data missing>";
      }
    },
    getReactionShort(input) {
      let reaction = "";
      if (input) {
        reaction = input.toLowerCase();
      }
      if (reaction == "indskærpelse") {
        return "Indskærpelsen";
      } else if (reaction == "påbud") {
        return "Påbuddet";
      } else if (reaction == "forbud") {
        return "Forbuddet";
      } else {
        return "<data missing>";
      }
    },
    date(date) {
      date = new Date(date);
      const options = { year: "numeric", month: "long", day: "numeric" };
      return date.toLocaleDateString("da-DA", options);
    },
    getEndDate(date) {
      date = new Date(date);
      date.setFullYear(date.getFullYear() + 2);
      const options = { year: "numeric", month: "long", day: "numeric" };
      return date.toLocaleDateString("da-DA", options);
    },
    listInfo(productCard) {
      let cvrNum = "";
      let batchNum = "";
      let barCode = "";
      let productNum = "";

      if (productCard.productNumbers.length > 0) {
        productCard.productNumbers.forEach((element) => {
          if (element) {
            if (element.productNumberType.name.toLowerCase() == "cvr_number") {
              cvrNum = element.number;
            } else if (
              element.productNumberType.name.toLowerCase() == "batch_number") {
              batchNum = element.number;
            } else if (
              element.productNumberType.name.toLowerCase() == "barcode") {
              barCode = element.number;
            } else if (
              element.productNumberType.name.toLowerCase() == "product_number") {
              productNum = element.number;
            }
          }
        });
      }

      let infoArray = [
        {
          id: 1,
          displayName: "Fabrikant",
          value: this.getResponsibleParty("manufacturer")
            ? this.getResponsibleParty("manufacturer")
            : productCard.manufacturer,
        },
        {
          id: 2,
          displayName: "Importør",
          value: this.getResponsibleParty("importer")
            ? this.getResponsibleParty("importer")
            : productCard.importer,
        },
        {
          id: 3,
          displayName: "Forhandler",
          value: this.getResponsibleParty("vendor")
            ? this.getResponsibleParty("vendor")
            : productCard.vendor,
        },
        { id: 4, displayName: "Batch-nummer", value: batchNum },
        { id: 5, displayName: "Varenummer", value: productNum },
        { id: 6, displayName: "Stregkode", value: barCode },
        {
          id: 7,
          displayName: "Håndhævelsesniveau",
          value: productCard.reaction.name_d,
        },
        { id: 8, displayName: "CVR-nummer", value: cvrNum },
      ];

      return infoArray;
    },
  },
  computed: {
    productCard: {
      get() {
        return this.$store.state.products.productCard;
      },
      set(value) {
        this.$store.commit("products/setProductCard", {
          productCard: value,
        });
      },
    },
  },
};
</script>

<style>
.product-info .card-img {
  border-radius: 0px;
}
.product-info .fact-box ul {
  list-style: none;
}
.product-info .product-numbers-list p {
  font-size: 0.85em;
}

@media only screen and (min-width: 576px) {
  .product-info .product-numbers-list p {
    font-size: 1em;
  }
}
</style>
